import React from 'react'
import { Container } from "./CMEProfileManagement/ModalContainer";
  
  export default function DeleteTopic(props:any){    
    
   const triggerText = "Delete Topic";  
   const modalHeaderText = "Are you sure?";
   const modalForText = "Delete"; 



  return (
    <Container 
    modalFor={modalForText}
    triggerText={triggerText} 
    modalHeaderText = {modalHeaderText}
    onSubmit={props.onSubmit} 
 
    />
  )
  }